module.exports = __webpack_public_path__ + "img/icon04.a8300ffe.png";